import '../../assets/index25.css';var X = Object.defineProperty, K = Object.defineProperties;
var L = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var $ = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var P = (t, e, a) => e in t ? X(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a, m = (t, e) => {
  for (var a in e || (e = {}))
    $.call(e, a) && P(t, a, e[a]);
  if (d)
    for (var a of d(e))
      w.call(e, a) && P(t, a, e[a]);
  return t;
}, N = (t, e) => K(t, L(e));
var R = (t, e) => {
  var a = {};
  for (var l in t)
    $.call(t, l) && e.indexOf(l) < 0 && (a[l] = t[l]);
  if (t != null && d)
    for (var l of d(t))
      e.indexOf(l) < 0 && w.call(t, l) && (a[l] = t[l]);
  return a;
};
import { jsx as r, jsxs as M } from "react/jsx-runtime";
import { forwardRef as Q, useState as _, useRef as W, useEffect as Z } from "react";
import { SearchFarFAIcon as T, StarFarFAIcon as G, XMarkFarFAIcon as J } from "../Icons/index.js";
import { Button as S } from "../Button/index.js";
import { T as v } from "../../index-DWf4motN.js";
import { I as O } from "../../Input--FNE961U.js";
import { F as U } from "../../Flex-BcSdq2bJ.js";
const Y = "SearchBar-module__wrapper___BqBZQ", ee = "SearchBar-module__standalone___3Lkhr", te = "SearchBar-module__standaloneExpanded___px1WR", ae = "SearchBar-module__table___IBgP8", re = "SearchBar-module__tableExpanded___HTKXH", ne = "SearchBar-module__leftSectionParent___bHuV1", le = "SearchBar-module__rightSectionParent___fqRcu", oe = "SearchBar-module__leftSection___Sku1g", se = "SearchBar-module__rightSection___2rVCI", ce = "SearchBar-module__section___zrDsI", ie = "SearchBar-module__input___gvTwC", n = {
  wrapper: Y,
  standalone: ee,
  standaloneExpanded: te,
  table: ae,
  tableExpanded: re,
  leftSectionParent: ne,
  rightSectionParent: le,
  leftSection: oe,
  rightSection: se,
  section: ce,
  input: ie
}, de = Q((_e, A) => {
  var h = _e, {
    placeholder: t = "Search...",
    onChange: e,
    onFavorite: a,
    defaultValue: l = "",
    value: i,
    onClick: u,
    variant: s = "default"
  } = h, y = R(h, [
    "placeholder",
    "onChange",
    "onFavorite",
    "defaultValue",
    "value",
    "onClick",
    "variant"
  ]);
  const [k, b] = _(l), [B, z] = _(!1), [V, x] = _(!1), [E, F] = _(!1), H = W(null), c = A || H;
  Z(() => {
    E && c && c.current && ([0, 50, 100, 200].forEach((g) => {
      setTimeout(() => {
        c.current && (c.current.focus(), console.log(`Focus attempt at ${g}ms`));
      }, g);
    }), F(!1));
  }, [E, c]);
  const f = i !== void 0 ? i : k, p = s === "standalone" || s === "table", j = (o) => {
    i === void 0 && b(o), e == null || e(o);
  }, q = () => {
    z(!B), a == null || a();
  }, C = (o) => {
    o.preventDefault(), o.stopPropagation(), i === void 0 && b(""), e == null || e(""), F(!0);
  }, I = () => {
    p && x(!0), u == null || u();
  }, D = () => {
    p && !f && x(!1);
  };
  return p && !V ? /* @__PURE__ */ r("div", { className: s === "table" ? n.table : n.standalone, children: /* @__PURE__ */ r(v, { label: "Search", position: "bottom", children: /* @__PURE__ */ r(
    S,
    {
      variant: "tertiary",
      size: "sm",
      onClick: I,
      "aria-label": "Search",
      children: /* @__PURE__ */ r(T, {})
    }
  ) }) }) : /* @__PURE__ */ r(
    "div",
    {
      className: `${n.wrapper} ${s === "standalone" ? `${n.standalone} ${n.standaloneExpanded}` : s === "table" ? `${n.table} ${n.tableExpanded}` : ""}`,
      children: /* @__PURE__ */ r(
        O,
        m({
          ref: c,
          classNames: N(m({}, n), {
            section: n.section,
            wrapper: `${n.leftSectionParent} ${n.rightSectionParent}`
          }),
          placeholder: t,
          value: f,
          onChange: (o) => j(o.currentTarget.value),
          onClick: I,
          onBlur: D,
          leftSection: /* @__PURE__ */ r("div", { className: n.leftSection, children: /* @__PURE__ */ r(T, {}) }),
          rightSection: /* @__PURE__ */ r("div", { className: n.rightSection, children: f && /* @__PURE__ */ M(U, { align: "center", gap: "xxs", children: [
            s !== "table" && /* @__PURE__ */ r(
              S,
              {
                variant: "tertiary",
                size: "sm",
                onClick: q,
                "aria-label": "Favorite",
                children: /* @__PURE__ */ r(G, { filled: B })
              }
            ),
            /* @__PURE__ */ r(v, { label: "Clear", position: "bottom", children: /* @__PURE__ */ r(
              S,
              {
                variant: "tertiary",
                size: "sm",
                onClick: (o) => C(o),
                "aria-label": "Clear",
                children: /* @__PURE__ */ r(J, {})
              }
            ) })
          ] }) })
        }, y)
      )
    }
  );
});
de.displayName = "SearchBar";
export {
  de as SearchBar
};
